import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import NewSponsorForm from "components/Admin/Sponsor/NewSponsorForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";

const { CREATE_SPONSOR_SAGA } = constants;

const { createSponsorSaga, cleanErrors } = actions;

class NewSponsor extends Component {
  static propTypes = {
    createSponsor: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    this.state = {
      sponsor: {
        title: "",
        logo: "",
        namespace: "",
        show_sponsor_title: true,
      },
    };
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const sponsorData = {
      ...this.state.sponsor,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ sponsor: sponsorData });
  };

  onSubmit = () => {
    this.props.createSponsor(this.state.sponsor);
  };

  render() {
    const { errors, errorsFrontend } = this.props;
    return (
      <main className="site--width clearfix-c">
        <NewSponsorForm
          onFieldChange={this.onFieldChange}
          sponsor={this.state.sponsor}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[CREATE_SPONSOR_SAGA],
    errorsFrontend: state.errors[`${CREATE_SPONSOR_SAGA}_FRONTEND`],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createSponsor: (sponsor) => dispatch(createSponsorSaga(sponsor)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_SPONSOR_SAGA)),
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewSponsor);



// WEBPACK FOOTER //
// ./src/containers/Admin/Sponsor/NewSponsor.jsx